import { render, staticRenderFns } from "./WeeklyProjectionAnalysisRequirement.vue?vue&type=template&id=4bb2e712&scoped=true"
import script from "./WeeklyProjectionAnalysisRequirement.vue?vue&type=script&lang=js"
export * from "./WeeklyProjectionAnalysisRequirement.vue?vue&type=script&lang=js"
import style0 from "./WeeklyProjectionAnalysisRequirement.vue?vue&type=style&index=0&id=4bb2e712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2e712",
  null
  
)

export default component.exports